<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Toon Producties</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="modal-content">
    <ion-list class="option-list">
      <ion-item
        (click)="setDisplayMode('active-show')"
        [class.selected]="displayMode === 'active-show'"
        button
        detail="false"
        lines="none"
        data-cy="filter-active-show">
        <ion-label>
          <h2>Actieve productie</h2>
          @if (activeShow) {
            <p>{{ activeShow.name }}</p>
          }
        </ion-label>
        @if (displayMode === 'active-show') {
          <ion-icon slot="end" name="checkmark-circle" color="primary"></ion-icon>
        }
      </ion-item>

      <ion-item
        (click)="setDisplayMode('all-shows')"
        [class.selected]="displayMode === 'all-shows'"
        button
        detail="false"
        lines="none"
        data-cy="filter-all-shows">
        <ion-label>
          <h2>Alle gekoppelde producties</h2>
          <p>{{ availableShows.length }} producties</p>
        </ion-label>
        @if (displayMode === 'all-shows') {
          <ion-icon slot="end" name="checkmark-circle" color="primary"></ion-icon>
        }
      </ion-item>

      <ion-item
        (click)="setDisplayMode('selected-shows')"
        [class.selected]="displayMode === 'selected-shows'"
        button
        detail="false"
        lines="none"
        data-cy="filter-selected-shows">
        <ion-label>
          <h2>Selecteer Producties</h2>
        </ion-label>
        @if (displayMode === 'selected-shows') {
          <ion-icon slot="end" name="checkmark-circle" color="primary"></ion-icon>
        }
      </ion-item>
    </ion-list>

    <!-- Show-selection list. Always rendered so the user can see what's
         available even when not in selected-shows mode; disabled (and
         visually greyed out) outside of that mode. -->
    <div class="show-selection" [class.show-selection--disabled]="displayMode !== 'selected-shows'">
      <ion-list class="show-list">
        @for (show of availableShows; track show) {
          <ion-item
            (click)="toggleShowSelection(show.id)"
            [class.selected]="isShowSelected(show.id)"
            [disabled]="displayMode !== 'selected-shows'"
            button
            detail="false"
            lines="none"
            data-cy="show-checkbox-item"
            >
            <ion-checkbox
              slot="start"
              [checked]="isShowSelected(show.id)"
              [disabled]="displayMode !== 'selected-shows'"
              (ionChange)="$event.stopPropagation()"
            ></ion-checkbox>
            <ion-label>
              <h3>{{ show.name }}</h3>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    </div>

    <div class="button-container">
      <ion-button
        (click)="confirmSelection()"
        [disabled]="!canConfirm()"
        expand="block"
        class="confirm-button"
        data-cy="filter-confirm"
        >
        Toepassen
      </ion-button>
    </div>
  </div>
</ion-content>
